import { FormikValues } from 'formik';

interface ValuesDisplayProps {
    values: FormikValues;
}

const ValuesDisplay = ({ values }: ValuesDisplayProps) => {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? (
        <div>{JSON.stringify(values, null, 2)}</div>
    ) : null;
};

export default ValuesDisplay;
